import {Component} from '../../utils/modules'
class Features extends Component {
    render() { 
        return <div>Featuers</div>;
    }
}
 
export default Features;